import {
  CartPosition,
  FontFamily,
  FontWeight,
  MenuPosition,
  OnlineTemplate,
  Shape,
  Size,
  TabsPosition,
  TextTransform,
} from "~/entities/templateEntities";

export const defaultTemplate: OnlineTemplate = {
  id: "",
  siteId: "",
  orgId: "",
  createdTime: "",
  updatedTime: "",
  code: "",
  name: "New template",
  active: true,
  default: true,

  global: {
    font: FontFamily.InstrumentSans,
    button: {
      primaryButtonColour: "#58348C",
      primaryButtonBorderColour: "#58348C",
      primaryButtonFontColour: "#FFFFFF",
      hoverPrimaryButtonColour: "#F2F2FF",
      hoverPrimaryButtonBorderColour: "#F2F2FF",
      hoverPrimaryButtonFontColour: "#58348C",
      secondButtonColour: "#FFFFFF",
      secondButtonBorderColour: "#D9D9D9",
      secondButtonFontColour: "#000000",
      hoverSecondButtonColour: "#F9F9F9",
      hoverSecondButtonBorderColour: "#D9D9D9",
      hoverSecondButtonFontColour: "#000000",
      buttonSize: Size.M,
      buttonStyle: Shape.FullyRoundedBox,
    },
    input: {
      backgroundColour: "#F4F4F4",
      borderColour: "#E0E0E0",
      focusBackgroundColour: "#FFFFFF",
      focusBorderColour: "#D6BEFB",
      fontColour: "#000000",
    },
    icon: {
      colour: "#58348C",
    },
    links: {
      termsAndConditions:
        "https://dnero.notion.site/Website-and-Online-Ordering-Terms-of-Use-1d1a215608d380a988ddd519e53964cd",
      privacyPolicy:
        "https://dnero.notion.site/Website-and-Online-Ordering-Privacy-Policy-1d1a215608d380c5aed6d8a162703c3f",
    },
  },

  navBar: {
    backgroundColour: "#FFFFFF",
    borderColour: "#D9D9D9",
    logo: {
      fileId: "f6fd851c-6498-4e6c-9a57-995a82fcf8da",
      fileName: "Group69.png",
      modifiers: null,
    },
    size: Size.S,
  },

  infoBar: {
    general: {
      backgroundColour: "#F3F3F3",
      fontColour: "#000000",
    },
    orderTime: {
      changeButtonColour: "#58348C",
    },
    authButton: {
      colour: "#000000",
      fontColour: "#FFFFFF",
      hoverColour: "#F3F3F3",
      hoverFontColour: "#000000",
      style: Shape.RoundedBox,
    },
    points: {
      fontSize: Size.L,
      fontColour: "#000000",
    },
    mobilePoints: {
      fontColour: "#58348C",
      viewButtonColour: "#58348C",
    },
  },

  menuBar: {
    site: {
      showSiteIcon: false,
    },
    general: {
      position: MenuPosition.Top,
      backgroundColour: "#FFFFFF",
      secondaryBackgroundColour: "#F6F6F6",
      showSocials: true,
      showCopyright: false,
    },
    menuItem: {
      fontSize: Size.L,
      fontColour: "#000000",
      showIcons: true,
      iconColour: "#000000",
      items: [
        {
          title: "My Orders",
          description: "Short Description",
          icon: null,
          column: 1,
          link: "#",
        },
        {
          title: "Store Locations",
          description: "Short Description",
          icon: null,
          column: 2,
          link: "#",
        },
        {
          title: "Allergen Information",
          description: "Short Description",
          icon: null,
          column: 2,
          link: "#",
        },
        {
          title: "About Us",
          description: "Short Description",
          icon: null,
          column: 3,
          link: "#",
        },
        {
          title: "Our Food",
          description: "Short Description",
          icon: null,
          column: 3,
          link: "#",
        },
        {
          title: "Our Innovations",
          description: "Short Description",
          icon: null,
          column: 3,
          link: "#",
        },
        {
          title: "Sustainability",
          description: "Short Description",
          icon: null,
          column: 3,
          link: "#",
        },
        {
          title: "Radio BurgerFuel",
          description: "Short Description",
          icon: null,
          column: 3,
          link: "#",
        },
      ],
    },
    topBar: {
      image: null,
      title: "Title",
      titleFontSize: Size.L,
      titleFontColour: "#000000",
      description: "Short Description",
      descriptionFontSize: Size.L,
      descriptionFontColour: "#000000",
    },
  },

  footer: {
    showFooter: false,
    primaryFontColour: "#000000",
    secondaryFontColour: "#000000",
    backgroundColour: "#FFFFFF",
    groups: [],
  },

  branding: {
    copyrightMessage: null,
    socials: [],
  },

  storesScreen: {
    general: {
      backgroundColour: "#FFFFFF",
      titleFontSize: Size.M,
      titleFontColour: "#000000",
    },
    card: {
      backgroundColour: "#FFFFFF",
      fontSize: Size.M,
      fontColour: "#000000",
      stroke: true,
      strokeColour: "#A0A0A0",
      buttonColour: "#58348C",
      buttonFontColour: "#FFFFFF",
      buttonStyle: Shape.FullyRoundedBox,
    },
  },

  menuScreen: {
    general: {
      backgroundColour: "#FFFFFF",
    },
    tabs: {
      widthImage: false,
      imageShape: Shape.Circle,
      position: TabsPosition.Top,
      backgroundColour: "#FFFFFF",
      borderColour: "#D9D9D9",
      shadow: false,
      itemBackgroundColour: "#FFFFFF",
      itemBorderColour: "#D9D9D9",
      itemFontColour: "#000000",
      selectedItemBackgroundColour: "#58348C",
      selectedItemBorderColour: "#58348C",
      selectedItemFontColour: "#FFFFFF",
      fontSize: Size.S,
      itemType: Shape.FullyRoundedBox,
    },
    category: {
      fontColour: "#58348C",
      fontSize: Size.L,
      fontFamily: FontFamily.VanguardCF,
      fontWeight: FontWeight.Bold,
      fontTransform: TextTransform.Uppercase,
    },
    card: {
      backgroundColour: "#FFFFFF",
      borderColour: "#E7E7E7",
      shadow: false,
      titleFontSize: Size.M,
      titleColour: "#000000",
      showDescription: true,
      descriptionFontSize: Size.M,
      descriptionColour: "#000000",
      priceFontSize: Size.M,
      priceColour: "#000000",
      imageBackgroundColour: "#f2f2f2",
      imageSize: Size.L,
      imageShape: Shape.Box,
    },
  },

  productScreen: {
    general: {
      backgroundColour: "#FFFFFF",
      sectionBackgroundColour: "#FFFFFF",
      sectionStroke: false,
      sectionStrokeColour: "#000000",
    },
    info: {
      imageBackgroundColour: "#f2f2f2",
      titleFontSize: Size.L,
      titleColour: "#000000",
      showDescription: true,
      descriptionFontSize: Size.S,
      descriptionColour: "#000000",
      descriptionExpandButtonColour: "#58348C",
      priceFontSize: Size.M,
      priceColour: "#000000",
      showAllergens: false,
      showAllergensIcon: true,
      allergensFontSize: Size.S,
      allergensFontColour: "#000000",
      allergensLink: "",
      allergensLinkColour: "#58348C",
    },
    modifiers: {
      headerBackgroundColour: "#ECECEC",
      headerFontSize: Size.S,
      headerFontColour: "#000000",
      fontSize: Size.S,
      fontColour: "#000000",
      priceColour: "#828282",
    },
  },

  cart: {
    position: CartPosition.AtTheTopRightCorner,
    backgroundColour: "#FFFFFF",
    fontColour: "#000000",
    showAdditionalProducts: true,
    item: {
      imageBackgroundColour: "#f2f2f2",
      nameFontSize: Size.M,
      nameFontColour: "#000000",
      modifiersFontSize: Size.M,
      modifiersFontColour: "#000000",
      priceFontSize: Size.M,
      priceFontColour: "#58348C",
    },
    offer: {
      icon: null,
      backgroundColour: "#E1DCEF",
      fontColour: "#000000",
    },
  },

  loyaltyDialog: {
    general: {
      titleFontSize: Size.M,
      titleFontColour: "#000000",
      subtitleFontSize: Size.M,
      subtitleFontColour: "#000000",
      pointsFontColour: "#58348C",
    },
    targetPoints: {
      show: false,
      backgroundColour: "#F2F2F2",
      progressBarColour: "#00BCEE",
      points: 1000,
    },
    card: {
      backgroundColour: "#FFFFFF",
      borderColour: "#FFFFFF",
      titleFontSize: Size.M,
      titleFontColour: "#58348C",
      descriptionFontSize: Size.M,
      descriptionFontColour: "#C4C4C4",
      buttonColour: "#00BCEE",
      buttonBorderColour: "#00BCEE",
      buttonFontColour: "#FFFFFF",
      buttonSize: Size.M,
      buttonStyle: Shape.RoundedBox,
      buttonHoverColour: "#00BCEE",
      buttonHoverBorderColour: "#00BCEE",
      buttonHoverFontColour: "#FFFFFF",
    },
  },

  loyalty: {
    text: {
      viewYourClubGoods: "View your Club Goods",
      joinOurLoyaltyProgram: "Join Our Loyalty Programme",
      haveAVoucherCode: "Have a voucher code?",
      usePromotion: "Use promotion",
      loginOrSignUp: "Login or Sign Up to VIB",
    },
  },

  checkoutScreen: {
    general: {
      backgroundColour: "#FFFFFF",
      sectionBackgroundColour: "#FFFFFF",
      sectionStroke: true,
      sectionStrokeColour: "#A0A0A0",
    },
    paymentMethod: {
      backgroundColour: "#F5F5F5",
      borderColour: "#E0E0E0",
      fontColour: "#000000",
      selectedBackgroundColour: "#E9E5F5",
      selectedBorderColour: "#6750A4",
      selectedFontColour: "#000000",
    },
  },
};
